import type { FormInstanceRowExtended } from "../models/FormInstanceRowExtended";
import type { GroupedSection } from "../models/GroupedSection";
import type { GroupedQuestion } from "../models/GroupedQuestion";
import type { GroupedInstanceResult } from "../models/GroupedInstanceResult";

export const getGroupedInstance = (
	formInstance: FormInstanceRowExtended[],
): GroupedInstanceResult => {
	const sectionsMap = new Map<number, FormInstanceRowExtended[]>();
	const questionsMap = new Map<number, FormInstanceRowExtended[]>();
	const sectionsOrder: number[] = [];
	const questionsOrder: number[] = [];

	formInstance.forEach((row: FormInstanceRowExtended) => {
		if (!sectionsMap.has(row.SectionId)) {
			sectionsMap.set(row.SectionId, []);
			sectionsOrder.push(row.SectionId);
		}
		sectionsMap.get(row.SectionId)?.push(row);

		if (!questionsMap.has(row.QuestionId)) {
			questionsMap.set(row.QuestionId, []);
			questionsOrder.push(row.QuestionId);
		}
		questionsMap.get(row.QuestionId)?.push(row);
	});

	const groupedSections: GroupedSection[] = sectionsOrder.map((sectionId) => ({
		sectionId,
		rows: sectionsMap.get(sectionId) || [],
	}));

	const groupedQuestions: GroupedQuestion[] = questionsOrder.map(
		(questionId) => ({
			questionId,
			rows: questionsMap.get(questionId) || [],
		}),
	);

	return {
		formInstance,
		groupedSections,
		groupedQuestions,
	} as GroupedInstanceResult;
};
